import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Utils/AxiosInstance";
import { revertAll } from "../../ResetStateAction";

const initialState = {
  Tags: [],
  isSuccess: false,
  message: null,
  status: "idle", //'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  IsLogin: true,
};

export const fetchTags = createAsyncThunk("/Tags", async (tagType) => {
  const response = await axiosInstance.get(`/Tags?type=${tagType}`);
  return response.data;
});

const TagsSlice = createSlice({
  name: "Tags",
  initialState,
  reducers: {
    TagsAdded: {
      reducer(state, action) {
        state.Tags?.push(action.payload);
      },
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)
      .addCase(fetchTags.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchTags.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Tags = action.payload.Data;
      })
      .addCase(fetchTags.rejected, (state, action) => {
        state.error = action.error.message;
        state.status = "failed";
      });
  },
});

export const getTagsDetails = state => state.Tags;

export const { TagsAdded } = TagsSlice.actions;

export default TagsSlice.reducer;
